import { type CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { createStore } from 'owa-satcheljs';
import type { CommandRibbonStore } from './schema/CommandRibbonStore';

export const getStore: () => CommandRibbonStore = createStore('CommandRibbon', {
    viewMode: 1,
    enabledKeytips: true,
});
